import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';

export default class ActiveLabel extends React.Component {

    render() {
        const {state} = this.props;

        const labelStyle = {
            backgroundColor: '#' + ( state && state.color ? state.color : '000' ),
            color: '#' + ( state && state.text_color ? state.text_color : 'fff' ),
        };

        return <span className="label" style={labelStyle}>{state && state.name ? state.name : ''}</span>;
    }

}

ActiveLabel.propTypes = {
    state: PropTypes.shape({
        name: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        text_color: PropTypes.string,
    }).isRequired,
};

ActiveLabel.defaultProps = {
    state: {name: '', color: '000', text_color: 'fff'},
};

export class ActiveBadge extends React.Component {

    render() {
        const {
            active,
            activeLabel = I18nUtils.tr('TR_ACTIVO'),
            inactiveLabel = I18nUtils.tr('TR_INACTIVO'),
        } = this.props;

        const labelStyle = {
            backgroundColor: active ? '#777777' : '#E3E3E3',
            color: active ? '#FFFFFF' : '#9E9E9E',
        };

        return (
            <span
                className="label"
                style={labelStyle}
                children={active ? activeLabel : inactiveLabel}
            />
        );
    }

}

ActiveBadge.propTypes = {
    active: PropTypes.bool.isRequired,
    activeLabel: PropTypes.string,
    inactiveLabel: PropTypes.string,
    minWidth: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/ActiveLabel.js